import _ from 'lodash';
import { formatNumWithKMB } from 'utils/helperMethods';

export function portfolioBubbleChartDataParser(data: any, portfolioAnalysisConfig: any) {
    let temp: any = [];
    const promoTypesChartLegends = portfolioAnalysisConfig.promoTypesChartLegends;

    try {
        data.forEach((singleAttributeData: any, index: any) => {
            const { attributeName, attributeData } = singleAttributeData;
            attributeData.forEach((singleMechanicsData: any) => {
                const { mechanicsName, mechanicsData } = singleMechanicsData;
                let promoMechanicsDataTemp: any = '';

                mechanicsData.forEach((singlePortfolioData: any) => {
                    const { kpisData, promoName } = singlePortfolioData;
                    const obj: any = {};
                    const arr: any = [];
                    const promoDetails = promoTypesChartLegends.filter(
                        (item: any) => item.label.toLowerCase() === promoName.toLowerCase(),
                    )[0];
                    kpisData.forEach((singleKpiData: any) => {
                        const { kpiName, kpiColor, kpiValue } = singleKpiData;
                        obj[kpiName] = kpiValue || 0;
                        obj['color'] = kpiColor;
                        obj['tacticsColor'] = promoDetails.color;
                        obj['mechanicsColor'] = promoMechanicsDataTemp?.color;
                    });

                    temp.push({
                        ...obj,
                        tactics: promoDetails.label || promoName,
                        name: attributeName,
                        mechanics: mechanicsName,
                    });
                });
            });
        });
        return temp;
    } catch (error) {
        console.log(error, 'logging error');
        throw error;
    }
}

export function getUniqueKpiList(data: any, portfolioAnalysisConfig: any) {
    const arrData: any = [];
    const labelKeyMapping: any = portfolioAnalysisConfig.chartHeaderLabelKeyMapping;
    if (data) {
        data[0]?.kpisData?.forEach((data: any) => {
            const { kpiName } = data;
            arrData.push({
                label: labelKeyMapping[kpiName]?.label || _.startCase(kpiName),
                value: kpiName,
                unit: '$',
            });
        });
        return arrData;
    } else return;
}
